import React from 'react';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';
import { FormGroup, Input, InputGroup } from 'reactstrap';

import { Intl } from 'components';
import InputGroupAddon from '../InputGroupAddon';

const TextFieldInput = React.memo( ( {
  label, value, inputOnChange, inputName, size = 'xsm', onChange, prependIconClass, prependIcon,
  appendIconClass, appendIcon, formGroupClass, intl, validateTranslateValues, isInvalid,
  disableOnEnter, allowZero = false, focused, meta, placeholder, translate = true, labelClass,
  labelOnFocus, inputClassName, ...rest
} ) => (
  <FormGroup className={classnames( formGroupClass, { 'is-invalid': isInvalid } )}>
    {label
    && (
      <label className={classnames( labelClass, 'form-control-label' )}>
        {translate ? <Intl id={label} /> : label}
      </label>
    )}

    <div className="w-100">
      <InputGroup className={classnames( 'input-group-merge', { focused } )}>
        {prependIcon || prependIconClass ? (
          <InputGroupAddon
            addonType="prepend"
            isInvalid={isInvalid}
            icon={prependIcon}
            iconClass={prependIconClass}
          />
        ) : null}

        <Input
          {...rest}
          placeholder={placeholder ? intl.formatMessage( { id: placeholder } ) : null}
          className={classnames( inputClassName, {
            'is-invalid': isInvalid,
            'form-control-lg': size === 'lg',
            'form-control-sm': size === 'sm',
            'form-control-xsm': size === 'xsm',
          } )}
          value={allowZero && value === 0 ? value : value || ''}
          onChange={( e ) => {
            let val = e.target.value;
            if ( rest && rest.type === 'number' ) {
              val = val === '' ? val : Number( val );
            }
            if ( inputOnChange ) inputOnChange( val );
            if ( onChange ) onChange( val );
          }}
          onKeyPress={disableOnEnter ? ( e ) => {
            if ( e.key === 'Enter' ) e.preventDefault();
          } : rest.onKeyPress}
        />

        {appendIcon || appendIconClass ? (
          <InputGroupAddon
            addonType="append"
            isInvalid={isInvalid}
            icon={appendIcon}
            iconClass={appendIconClass}
          />
        ) : null}
      </InputGroup>

      {labelOnFocus && focused
      && (
        <label className="form-control-label mb-1">
          <Intl id={labelOnFocus} />
        </label>
      )}
      {isInvalid
      && (
        <div className="invalid-feedback">
          <Intl id={meta.error || meta.submitError} values={validateTranslateValues} />
        </div>
      )}
    </div>
  </FormGroup>
) );

export default injectIntl( TextFieldInput );
